import React, { FC } from 'react'
import { observer } from 'mobx-react'
import CategoryBar from '../CategoryBar'
import './index.scss'
import EatTypeBar from '../../../../menu/components/MenuStyleWaterfall/EatTypeBar'

const MenuLeftBar: FC = () => {
  return (
    <div className='menu-style-left-bar-container eatType-container'>
      <EatTypeBar />
      <CategoryBar />
    </div>
  )
}

export default observer(MenuLeftBar)
